<template>
  <div>
    <h2 class="content-block">Datagrid Date Validation</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dx-data-grid
          :dataSource="dataSource"
          :columns="columns"
          :editing="editingOptions"
        >
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import {
  DxDataGrid,
  // DxDateBox
} from "devextreme-vue";

export default {
  components: {
    DxDataGrid,
    // DxDateBox,
  },
  data() {
    return {
      dataSource: [
        { id: 1, name: "John", birthdate: "1990-01-01" },
        { id: 2, name: "Jane", birthdate: "1995-05-05" },
      ],
      columns: [
        { dataField: "id", caption: "ID" },
        { dataField: "name", caption: "Name" },
        {
          dataField: "birthdate",
          caption: "Birthdate",
          dataType: "date",
          format: "dd/MM/yyyy",
          editorType: "dxDateBox",
          editorOptions: {
            width: "100%",
            type: "date",
            displayFormat: "dd/MM/yyyy",
          },
        },
      ],
      editingOptions: {
        allowUpdating: true,
        mode: "row",
      },
    };
  },
};
</script>
